import { Box, Text } from '@chakra-ui/react';
import { NegativeSixDP } from 'components/maintenance/NumberFormatCustom';

const LineTotalDisplay = ({ darkMode, value }) => {
    return (
        <Box mb={6}>
            <Text 
                fontWeight="semibold" 
                color={darkMode ? 'white' : 'gray.700'}
                mb={2}
            >
                Line Total
            </Text>
            <Text 
                color={darkMode ? 'gray.300' : 'gray.600'}
                fontSize="md"
            >
                <NegativeSixDP displayType="text" value={value} />
            </Text>
        </Box>
    );
};

export default LineTotalDisplay;